import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-barcode-icon',
  templateUrl: './shopping-barcode.component.html'
})
export class ShoppingBarcodeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
